import handleGlobalRedirect from "MMT-UI/UpdateGlobalURL";
import { getEntityType } from "./CommonUtils";

export default async function (params) {
  const {
    req,
    res,
    sanitizedParams: query,
    currentDomainName: hostName,
    isIntl,
    localeSettings,
    isBot,
  } = params || {};
  if (localeSettings) {
    let returnRedirectObject = {};
    const customUrl = customRedirectionUrl(query, hostName, isIntl, req);
    if (customUrl) {
      returnRedirectObject = {
        redirect: {
          destination: `https:${customUrl}`,
          statusCode: 301,
        },
      };
      return returnRedirectObject;
    }
    await handleGlobalRedirect({
      isGlobalEnable: localeSettings?.isGlobalFlagEnabled || false,
      callBackRedirection(url) {
        if (url && localeSettings?.isGlobalFlagEnabled && !isBot) {
          returnRedirectObject = {
            redirect: {
              destination: url,
              statusCode: 302,
            },
          };
          return returnRedirectObject;
        }
      },
      req,
      res,
    });
    if (res.statusCode === 302) {
      return returnRedirectObject; // Ensure no further code is executed after the redirect
    }
    return returnRedirectObject;
  }
}

function customRedirectionUrl(query, hostName, isIntl, req) {
  if (getEntityType(hostName) === "IN" && query && query?.length > 1 && isIntl) {
    // redirect to mmt.global or ae.mmt.global
    if (query[0] === "united_arab_emirates") {
      return `//ae.makemytrip.global${req.url}`;
    } else if (query[0] === "saudi_arabia") {
      return `//sa.makemytrip.global${req.url}`;
    } else {
      return `//www.makemytrip.global${req.url}`;
    }
  } else if (getEntityType(hostName) === "AE") {
    if (!isIntl) {
      return `//${hostName}/flights/`;
    }
    if (query && query?.length === 1) {
      return `//${hostName}/flights/`;
    }
    if (query[0] !== "united_arab_emirates") {
      return `//${hostName}/flights/`;
    }
  } else if (getEntityType(hostName) === "SA") {
    if (!isIntl) {
      return `//${hostName}/flights/`;
    }
    if (query && query?.length === 1) {
      return `//${hostName}/flights/`;
    }
    if (query[0] !== "saudi_arabia") {
      return `//${hostName}/flights/`;
    }
  } else if (getEntityType(hostName) === "GLOBAL") {
    if (!isIntl) {
      return `//${hostName}/flights/`;
    }
    if (query && query?.length === 1) {
      return `//${hostName}/flights/`;
    }
    if (query && query?.length > 1 && query[0] === "united_arab_emirates") {
      //redirect to ae.mmt.global
      return `//ae.makemytrip.global${req.url}`;
    }
    if (query && query?.length > 1 && query[0] === "saudi_arabia") {
      //redirect to ae.mmt.global
      return `//sa.makemytrip.global${req.url}`;
    }
  }
  return "";
}
